const ITEMS = [
  "UPFRONT PRICING",
  "LIFETIME LABOUR WARRANTY",
  "HAPPINESS GUARANTEE",
  "LIVE AVAILABILITY",
  "LICENSED & INSURED",
  "FIND IT. FIX IT. DONE.",
];

export const Marquee = ({ className = "" }) => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className={`bg-brand py-5 overflow-hidden border-y-4 border-navy ${className}`}>
      <div className="flex w-max animate-marquee gap-0">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center font-bebas text-2xl sm:text-3xl tracking-wider text-white whitespace-nowrap px-6">
                {item}
                <span className={`ml-12 ${i % 2 === 0 ? "text-tpink" : "text-tlime"}`}>•</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
